import React from "react";
import { createRoot } from "react-dom/client";
import { markerPopUpContent } from "./markerModal";
import MarkerRenderComponent from "./renderComponent";
import { isArray } from "lodash";


export const addMarkers = (mapboxgl, markerGeoPts, mapRef, fileScope, scopeId, user, setSelectedVesselId, geoPointsValidaterArray, markerRefs, handleOnAction) => {
    console.log("MARKER GEO PTS : ", markerGeoPts)

    const validateGeoPoints = () => {
        return markerGeoPts.map((point) => {
            const isValidLat = point.Latitude >= -90 && point.Latitude <= 90;
            const isValidLon = point.Longitude >= -180 && point.Longitude <= 180;

            const correctedPoint = isValidLat && isValidLon
                ? { ...point }
                : { ...point, Latitude: 0, Longitude: 0 };

            // console.log("Corrected Point:", correctedPoint);

            return correctedPoint;
        });
    };


    const createMarkersSource = () => ({
        type: "geojson",
        data: {
            type: "FeatureCollection",
            features: validateGeoPoints().map((point) => {
                // console.log("===========UDATED point ==================>>>>> ", point)
                return (
                    {
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: [point.Longitude, point.Latitude],
                        },
                        properties: { point },
                    }
                )
            })
        },
    });

    // Add markers to the map
    const addMarkersToMap = () => {
        const sourceId = "points";
        if (mapRef.getSource(sourceId)) {
            mapRef.removeLayer(sourceId);
            mapRef.removeSource(sourceId);
        };

        mapRef.addSource(sourceId, createMarkersSource());
        mapRef.addLayer({
            id: sourceId,
            type: "circle",
            source: sourceId,
            paint: {
                "circle-radius": 1,
                "circle-color": "transparent",
            },
        });

        // Render markers
        validateGeoPoints().forEach((point) => {
            const ref = document.createElement("div");
            ref.style.textAlign = "center";

            const markerKey = `${point["Vessel ID"]}|${point["KIT Number"]}|${point["Latitude"]}|"${point["Longitude"]}`;

            createRoot(ref).render(
                <MarkerRenderComponent
                    key={markerKey}
                    iconUrl={
                        isArray(geoPointsValidaterArray) &&
                        (geoPointsValidaterArray.find(obj => obj._terminalUpdateId === point._terminalUpdateId) || {}).iconUrl || ""
                    }
                    vesselId={point.id}
                    markerSize={point.markerSize ?? ""}
                    markerColor={point.color ?? point.markerColor}
                    iconType={point.iconType ?? ""}
                    iconDirection={point?.value?.direction ?? ""}
                    vesselType={point.tooltip}
                    isMarkerChecked={point.isMarkerChecked ?? false}
                    handleOnMarkerClick={async () => {

                        // Remove all existing popups
                        markerRefs.current.forEach((ref, key) => {
                            if (ref?.popup) {
                                try {
                                    ref.popup.remove();
                                    ref.popup = null;
                                } catch (err) {
                                    console.warn(`Failed to remove popup for ${key}`, err);
                                }
                            }
                        });

                        setSelectedVesselId((pre) => (pre === point.id ? null : point.id));

                        const popup = await markerPopUpContent(
                            point,
                            fileScope,
                            scopeId,
                            user,
                            mapRef,
                            handleOnAction
                        );

                        const refData = markerRefs.current.get(markerKey);

                        if (!refData?.marker) {
                            console.warn("No marker found for key:", markerKey);
                            return;
                        }

                        popup.setLngLat(refData.marker.getLngLat());
                        refData.marker.setPopup(popup);
                        refData.popup = popup;
                        popup.addTo(mapRef);
                    }}
                />
            );

            const marker = new mapboxgl.Marker({ element: ref, draggable: false })
                .setLngLat([point.Longitude, point.Latitude])
                .addTo(mapRef);

            markerRefs.current.set(markerKey, { marker, popup: null });
        });
    };

    if (!mapRef.isStyleLoaded()) {
        mapRef.on("style.load", addMarkersToMap);
        return;
    }
    addMarkersToMap();
};